"use strict";

var cov_1p7awhcpsl = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\SectionObject.js";
  var hash = "1288249e9c712a1958e94be0568f7bebb4e80b57";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\SectionObject.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 15,
          column: 4
        }
      },
      "1": {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 24,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "SectionObject",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 22
          }
        },
        loc: {
          start: {
            line: 9,
            column: 3
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 9
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "1288249e9c712a1958e94be0568f7bebb4e80b57"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function SectionObject(_ref) {
  var verseObject = _ref.verseObject;
  cov_1p7awhcpsl.f[0]++;
  cov_1p7awhcpsl.s[0]++;
  return _react.default.createElement(_core.Typography, {
    variant: "h4",
    gutterBottom: true
  }, verseObject.content);
}

;
cov_1p7awhcpsl.s[1]++;
SectionObject.propTypes = {
  verseObject: _propTypes.default.shape({
    tag: _propTypes.default.string,
    type: _propTypes.default.string,
    content: _propTypes.default.string
  }).isRequired
};
var _default = SectionObject;
exports.default = _default;